import React from 'react';
import { SectionCta } from './SectionCta';
import { subtleSignals } from '../data/content';
export function Story() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-labelledby="story-title" data-id="element-281" data-mp="1iaud91v6fy3y">
      <div className="mx-auto max-w-3xl" data-id="element-282" data-mp="1n46s4ka20qji">
        <h2 id="story-title" className="text-center font-display text-4xl font-bold uppercase leading-[1.08] text-navy-900 sm:text-5xl" data-id="element-283" data-mp="1n5ht6cc47k6x">
          Stop hoping everything goes according to plan.
        </h2>
        <p className="mt-4 text-center font-display text-2xl font-medium uppercase leading-snug text-radar-deep sm:text-3xl" data-id="element-284" data-mp="zd1co681009q">
          Start recognizing the warning signs before they become complications.
        </p>

        <div className="mt-10 space-y-5 text-lg leading-relaxed text-ink" data-id="element-285" data-mp="18fametvgzpm2">
          <p data-id="element-286" data-mp="2fscbb2lgm7h8">I created Implant Risk Radar™ for one specific reason:</p>
          <p className="text-xl font-semibold" data-id="element-287" data-mp="2fu5m8u33vdv1">
            Because during implant surgery, the most dangerous moment isn't always when something obviously goes wrong.
          </p>
          <p data-id="element-288" data-mp="18zz3ks6mj8fe">Sometimes, the first sign is subtle.</p>
        </div>

        <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-289" data-mp="14406mg78ci3d">
          {subtleSignals.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex items-center gap-3.5 rounded-xl bg-canvas p-4" data-id="element-290" data-mp="z2awr3vquagv">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-navy-900" data-id="element-291" data-mp="v1ioodylybm6">
                <Icon className="h-5 w-5 text-radar" aria-hidden="true" data-id="element-292" data-mp="q4s9rtyjhm2c" />
              </span>
              <span className="text-[17px] font-medium leading-snug text-ink" data-id="element-293" data-mp="lawe4y5r0bac">{text}</span>
            </li>)}
        </ul>

        <div className="mt-10 space-y-5 text-lg leading-relaxed text-ink" data-id="element-294" data-mp="gb1jqkmrl3kj">
          <p data-id="element-295" data-mp="bg4dtmks7abv">
            The problem is that when you don't have a structured way to recognize these signals, it's easy to keep
            going and hope the situation resolves itself.
          </p>
          <p className="border-l-4 border-alert py-1 pl-5 font-display text-3xl font-semibold uppercase leading-tight text-navy-900" data-id="element-296" data-mp="2eemegqwgbe3">
            I don't want you to rely on hope.
          </p>
          <p data-id="element-297" data-mp="3sybe1bv589j5">
            I want you to have a system for recognizing the warning signs, reassessing the situation, and knowing when
            the safest next step is to <strong data-id="element-298" data-mp="3jvilz6e4zts9">pause</strong>, <strong data-id="element-299" data-mp="3jx3gwx4d5eqn">reconsider the plan</strong>, or{' '}
            <strong data-id="element-300" data-mp="bgqtdwlx6zac">seek additional support</strong>.
          </p>
        </div>

        <SectionCta label="I'm ready to stop relying on hope" data-id="element-301" data-mp="biuw4b831s91" />
      </div>
    </section>;
}